import { useState } from "react";
import { toast } from "sonner";
import { ArrowLeft, X } from "lucide-react";
import { api, errMsg, img } from "@/lib/api";

export const ImagesEditor = ({ images, onChange }) => {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const added = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/admin/upload", fd);
        added.push(data);
      }
      onChange([...images, ...added]);
      toast.success("Immagini caricate — ricorda di salvare");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  const move = (i) => onChange([images[i], ...images.filter((_, k) => k !== i)]);

  return (
    <div data-testid="images-editor">
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-5">
        {images.map((im, i) => (
          <div key={im.url} className={`group relative aspect-square overflow-hidden rounded-xl bg-white ${i === 0 ? "ring-2 ring-[#0066FF]" : ""}`}>
            <img src={img(im.url)} alt="" className="h-full w-full object-contain p-1" />
            <div className="absolute inset-x-0 bottom-0 flex justify-between bg-black/70 p-1 opacity-0 transition-opacity group-hover:opacity-100">
              {i > 0 ? <button onClick={() => move(i)} title="Imposta come principale" className="p-1 text-white" data-testid={`image-make-main-${i}`}><ArrowLeft className="h-3.5 w-3.5" /></button> : <span className="px-1 text-[10px] text-white">Principale</span>}
              <button onClick={() => onChange(images.filter((_, k) => k !== i))} title="Rimuovi" className="p-1 text-red-300" data-testid={`image-remove-${i}`}><X className="h-3.5 w-3.5" /></button>
            </div>
          </div>
        ))}
        <label className="flex aspect-square cursor-pointer items-center justify-center rounded-xl border border-dashed border-white/20 text-center text-xs text-slate-400 hover:border-[#0066FF]">
          {busy ? "Caricamento…" : "+ Aggiungi"}
          <input type="file" accept="image/*" multiple className="hidden" onChange={upload} data-testid="image-upload-input" />
        </label>
      </div>
    </div>
  );
};
